/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useContext, useEffect } from 'react';

import Input from './common/Input';
import { Form } from 'react-bootstrap';
import Axios from 'axios';
import { XSquare } from 'react-bootstrap-icons';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { useForm } from "react-hook-form";


const SingleSlider = (props) => {

    const [imageTitle, setImageTitle] = useState(props.image.imagetitle);
    const [imageMessage, setImageMessage] = useState(props.image.imagemessage);
    const [button1Title, setButton1Title] = useState(props.image.button1title);
    const [button2Title, setButton2Title] = useState(props.image.button2title);
    const [button1Link, setButton1Link] = useState(props.image.button1link);
    const [button2Link, setButton2Link] = useState(props.image.button2link);

    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);

    const fetchClient = () => {
        coreContext.fetchSelf(authContext.itemId);
        setValue('imagetitle', props.image.imagetitle);
        setValue('imagemessage', props.image.imagemessage);
        setValue('button1title', props.image.button1title);
        setValue('button1link', props.image.button2title);
        setValue('button2title', props.image.button1link);
        setValue('button2link', props.image.button2link);
    }

    useEffect(fetchClient, []);


    const { register, handleSubmit, formState: { errors }, setValue } = useForm({});
    // const onSubmit = data => console.log(data);

    const onImageDetailsHandler = (data) => {
        console.log('singleslider', data);
        const { imagetitle, imagemessage, button1title, button2title, button1link, button2link } = data;
        coreContext.updateSliderImage(imagetitle, imagemessage, button1title, button2title, button1link, button2link, authContext.itemId, props.image.id);

    }


    const deleteImage = () => {
        const id = props.image.id;
        deleteSliderImage(id);
    }

    const deleteSliderImage = (id) => {

        Axios.post('/delete-slider-image', { id }).then((response) => {
            const images = coreContext.homeSliderImages;
        const newImages = images.filter(image => image.id !== id);
        coreContext.setHomeSliderImages(newImages);
        }).catch(err => { });
    }


    return (
        <div className="col-md-3"><img style={{ padding: 5 }} className="img-fluid" src={`http://${props.image.url}`} alt='gallery image' /> 
            <Form autoComplete='off' onSubmit={handleSubmit(onImageDetailsHandler)} noValidate>
                <Input label='Image Title' name='imagetitle' minLength={2} maxLength={155} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Image Title' />

                <Input label='Image Message' value={imageMessage} name='imagemessage' minLength={2} maxLength={155} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Image Message' />

                <Input label='Button-1 Title' value={button1Title} name='button1title' minLength={2} maxLength={25} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Button-1 Title' />

                <Input label='Button-1 Link' value={button1Link} name='button1link' minLength={2} maxLength={155} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Button-1 Link' />

                <Input label='Button-2 Title' value={button2Title} name='button2title' minLength={2} maxLength={25} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Button-2 Title' />

                <Input label='Button-2 Link' value={button2Link} name='button2link' minLength={2} maxLength={155} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Button-2 Link' />

                <Input elementType='button' variant='primary' value="Update" /> &nbsp;&nbsp;  <button onClick={() => deleteImage()} type="button" className="btn btn-danger btn-sm" title="Delete Image"> <XSquare size="12" /> </button> &nbsp;&nbsp; {coreContext.renderLoader()}
                <Input variant='danger' label={coreContext.message} elementType='label' />
            </Form>
        </div>
    )
}

export { SingleSlider }